@if (active) {
    <cl-dialogue
        [title]="setup?.title"
        (primaryButtonClicked)="confirm()"
        [secondaryButtonText]="'Cancel'"
        (secondaryButtonClicked)="cancel()"
        (closed)="cancel()"
    >
        <div>{{ setup?.text }}</div>
    </cl-dialogue>
}
